const TRANSLATION = {
  buyModal: {
    afterFree: 'तव मुफ्त परीक्षणे पश्चात्',
    btn: 'मुफ्तमया प्रयत्नयताम्',
    freeTrial: 'त्रिदिनकालिकः मुफ्तः परीक्षणः',
    monthLabel: 'मासः',
    selectLabel: 'एकं योजनां चिनुत',
    title: 'सदस्यता योजना',
    yearLabel: 'वर्ष',
  },
  contact: {
    block1:
      'सानुकूलन, प्रश्नान् वा सुझावान् यतः, कृपया contact@noam.tools इति पत्रेण संपर्कं करोतु. अस्माभिः शीघ्रं प्रत्युत्तरं ददामः.',
    block2: 'गूगल अप्स एक्स्टेंशन स्टोर में ★★★★★ रेटिंग देकर हमें सहायता करें।',
    block3: 'एतस्य प्रस्तरणम् (एक्स्टेंशनम्) साझयित्वा अन्यान् परोपकारयत',
    title: 'आमहम् संपर्कयताम्',
  },
  help: {
    AquickOverviewOfNoam: 'नोमकः संक्षिप्तः अवलोकनम्',
    ChatPDF: 'चैट पीडीएफ',
    ChatPDF2: 'चैटपीडीएफ',
    FavoritesManagement: 'प्रियवस्तु प्रबन्धनम्',
    Fixedplugin: 'स्थिर प्लगइन',
    Focusing: 'ध्यानम्',
    Free: 'मुक्तः',
    FreeTrialBenefits: 'मुफ्त परीक्षण लाभाः',
    GoWithWikipedia: 'विकिपीडियासह यान्तु',
    GoWithYouTube: 'यूट्यूबम् सह यानम्',
    HoverTranslation: 'होवर अनुवादः',
    Howtouse: 'कथं प्रयोजयेत्',
    ImageTranslation: 'प्रतिमा अनुवाद',
    InstantTranslation: 'तत्क्षणानुवादः',
    Membership: 'सदस्यता',
    NoamHelp: 'नोमः त्वाम् अनुवादयति च सारांशयति च',
    PDFparallelTranslation: 'पीडीएफ समानांतर अनुवाद',
    ParallelTranslation: 'समानांतर अनुवाद',
    SkipAllSteps: 'सर्वान् पदानि त्यजतु',
    Summary: 'सारांशः',
    Translation: 'अनुवाद',
    TryItForFree: 'मुफ्तमया प्रयत्नं करोतु',
    Video: 'वीडियो',
    VideoSummary: 'वीडियो सारांश',
    VideoTranslation: 'वीडियो अनुवाद',
    WebSummary: 'वेब सारांशः',
    WordSelectionTranslation: 'शब्द-चयन-अनुवादः',
    benefits: 'भवत्सु लभ्या: फलानि अपेक्षते!',
    dayFree: 'त्रिदिवसीय निःशुल्क परीक्षणम्',
    done: 'कृतम्',
    next: 'अग्र',
    pin: 'नोमं सुलभप्राप्त्यै पिन कुरु～～',
    planIsNotExist: 'योजना उपलब्ध नहीं है',
    startWiki: 'विकिमीडियासह स्वयं आरंभ करावैया!',
    startYoutube: 'यूट्यूबसह सुरुवात करूयाम्!',
    try: 'इदं प्रयोजयताम्',
    tryNow: 'अभ्यासं कुरु नूनम्!',
  },
  home: {
    PDFTranslate: {
      desc: 'द्विभाषिक अनुवाद + चैट पीडीएफ',
      sub1: {
        desc: 'द्विभाषिकं पठनं त्वयि मूलपाठं च अनुवादं च समीपे समीक्षयितुं ददाति, पठनकुशलताम् वृद्धयति।',
        title: 'द्विभाषिकं पठनम्',
      },
      sub2: {
        desc: 'एआई (AI) विश्लेषणं कृत्वा सारांशं निर्माणयति, तथा पीडीएफ (PDF) सामग्रीवर्भूतं प्रश्नान् उत्तरति।',
        title: 'चैट पीडीएफ',
      },
      sub3: {
        desc: 'आर्टिफिशियल इंटेलिजेंस-सहायित पीडीएफ अनुवादः अधिक शुद्धता और कुशलता हेतु',
        title: 'सूक्ष्मता च कुशलता च',
      },
      title: 'पीडीएफ अनुवाद',
    },
    aiAssistant: {
      desc: 'वेबानुवादं बुद्धिमत्तरं च सुविधाजनकतरं च करणम्',
      panel1: {
        desc: 'द्विभाषिकः अनुप्रस्थान-संदर्भः अनुवादाः त्वाम् मूलपाठं अनुवादेन सम्भावयitum् सहायति, ततः त्वं अधिकं समझitum् शक्स्यसि च तव पठन-कुशलता विकस्यते।',
        title: 'द्विभाषी अनुवादः',
      },
      panel2: {
        left: {
          desc: 'वेब पृष्ठं परिश्रेणीभूते समये, त्वं अनुवादनीयं सामग्रीपर्यन्तं होवर कर, अनुवादं देख।',
          title: 'होवर अनुवादः',
        },
        right: {
          desc: 'वेब पृष्ठं परिभ्राम्य, त्वं जो पाठं अनुवादितुं चाहसि तं चिन्हय, अनुवादं द्रष्टुम्।',
          title: 'पाठ-चयन-अनुवादः',
        },
      },
      panel3: {
        one: {
          desc: 'वेबपृष्ठानि च वीडियो सामग्री च कदाचित् कुत्रचित् अनुवद्य सारांशं कुर्वन्तु, सुखकरतरं अनुभवं प्राप्तुं!',
          title: 'निर्दिष्टं क्लिक् करोतु',
        },
        three: {
          desc: 'एआई-चालकः महान् भाषा-मॉडेलः अनुवादस्य शुद्धताम् और सुस्थिरताम् सुनिश्चयति, ताकि पठन-अनुभवः सुध्यते।',
          title: 'एआई-संचालित',
        },
        two: {
          desc: 'अनेकभाषा पूर्णावृत्ति, द्विभाषिक अवरोधरहित पठन, एक-क्लिक अनुवाद - भेदं अनुभवयतु!',
          title: 'अधिक व्यापकं च सुविधाजनकं च',
        },
      },
      panel4: {
        tab1: {
          desc: 'त्वं प्रभावी विशेषज्ञः - चैटजीपीटी प्रयोग्यः, नोअमः यूट्यूब वीडियो सामग्रीं प्रत्यर्पयति सारांशयति च त्वाम् कालम् रक्षति!',
          key: 'वीडियो',
          title: 'वीडियो अनुवादः च सारांशः',
        },
        tab2: {
          desc: 'वेब ब्राउज़ करते समय चित्रों का अनुवाद करने के लिए क्लिक करें।',
          key: 'प्रतिमा',
          title: 'प्रतिमा अनुवाद',
        },
        tab3: {
          desc: 'वेबपृष्ठान्‌ म्‌ध्यात्‌ मुख्यं ज्ञानम्‌ तत्क्षणेन्‌ निष्कर्षयति सारांशं च प्रददाति, त्वद्‌ अध्ययन-कुशलताम्‌ वृद्धयति।',
          key: 'वेब्',
          title: 'वेब अनुवादः च सारांशः',
        },
        tag1: 'सरल (Sarala)',
        tag2: 'कुशल',
        tag3: 'सुलभं बोधनीयम्',
      },
      title: 'एआई सहायक',
    },
    getStart: 'आरम्भ कर',
    getStartedForFree: 'मुफ्तमेव प्रारम्भ करोतु',
    howItWork: {
      desc: 'नोम् एआई मॉडेलों का समाकलन करता है ताकि उपयोगकर्ताओं को अंतर-भाषाई वेब पृष्ठ अनुवाद और सारांश, पीडीएफ और छवि अनुवाद, वीडियो अनुवाद और सारांश के लिए बुद्धिमान अनुभव प्रदान किया जा सके',
      title: 'यथा यत् कार्यं क्रियते',
    },
    lastBlock: { desc: 'श्रेयस्करं एआई अनुवादः सुखकरेण पठनेऽनुभवाय' },
    top: {
      desc: 'नोम् एक मुक्त एआई ब्राउज़र एक्स्टेंशन आहे जो तुम्हाला वेब पृष्ठे, व्हिडिओ आणि पीडीएफ सामग्रीचे अनुवाद आणि सारांश करण्यात मदत करतो।\n      नोम् मध्ये सामील होऊन जादू अनुभवा!',
      title1: 'एक माया',
      title2: 'एक क्लिकः',
    },
    userReviews: { desc: 'क्रोम वेब स्टोर पर पंचतारांकीय समीक्षाः', title: 'प्रयोक्ता समीक्षाः' },
  },
  installTips: {
    btn: 'अद्यैव प्रयत्नं कुरु',
    text: 'अधिक सुविधाओं को अनलॉक करने के लिए "नोम ब्राउज़र प्लगइन" स्थापित करें! वेब क्रॉस-रेफरेंसिंग,\n    वेब वीडियो सारांश, और बहुत कुछ!',
  },
  locale: {
    af: 'अफ्रीकान्स',
    am: 'अम्हारिक',
    ar: 'अरबिक',
    as: 'असमी',
    auto: 'स्वतः परिचयनम्',
    az: 'अज़ेरबैजानी',
    ba: 'बाश्किर',
    bg: 'बुल्गारियाई',
    bn: 'বাংলা',
    bo: 'तिब्बती',
    bs: 'बोस्नियाई',
    ca: 'कैटलान',
    cs: 'चेक',
    cy: 'वेल्श',
    da: 'डेनिश',
    de: 'जर्मन',
    dsb: 'लोअर सोर्बियन्',
    dv: 'दिवेही',
    el: 'यवन',
    en: 'अङ्ग्लभाषा',
    es: 'स्पेनिश',
    et: 'एस्टोनियाई',
    eu: 'बास्क',
    fa: 'पर्शियन्',
    fi: 'फिन्निश',
    fil: 'फिलिपिनो',
    fj: 'फिजी भाषा',
    fr: 'फ्रान्सिकी',
    frCA: 'फ्रेंच (कनाडा)',
    ga: 'आयरिश',
    gl: 'गैलिशियन्',
    gom: 'कोंकणी',
    gu: 'ગુજરાતી',
    ha: 'हौसा',
    he: 'हिब्रू',
    hi: 'हिन्दी',
    hr: 'क्रोएशियाई',
    hsb: 'उपरerior सोर्बियन्',
    ht: 'हैतियन क्रियोल',
    hu: 'हंगेरियन',
    hy: 'आर्मेनियन',
    id: 'इण्डोनेशियाई',
    ig: 'इग्बो',
    ikt: 'इनुइन्नाक्टुन',
    is: 'आइसलैण्डिक',
    it: 'इटालियन',
    iu: 'इनुक्तितुत्',
    iuLatn: 'इनुक्तितुत्',
    ja: 'जापानी',
    ka: 'ജോർജിയൻ',
    kk: 'कज़ाख',
    km: 'ख्मेर',
    kmr: 'कुर्दी (उत्तरी)',
    kn: 'ಕನ್ನಡ',
    ko: 'कोरियाई',
    ku: 'कुर्दिश (मध्य)',
    ky: 'किर्गिज़',
    ln: 'लिंगाला',
    lo: 'लाओ',
    lt: 'लिथुआनियाई',
    lug: 'गन्द',
    lv: 'लात्वियाई',
    lzh: 'चीनी (साहित्यिक)',
    mai: 'मैथिली',
    mg: 'मलागासी',
    mi: 'माओरी',
    mk: 'मैसेडोनियाई',
    ml: 'മലയാളം',
    mnCyrl: 'मङ्गोलियन (सायरिल्लिक)',
    mnMong: 'मङ्गोलियन (परंपरागत)',
    mr: 'मराठी',
    ms: 'मलय',
    mt: 'माल्टीज़',
    mww: 'ह्मोंग दाव',
    my: 'म्यान्मार (बर्मीज)',
    nb: 'நோர்வேஜியன்',
    ne: 'नेपाली',
    nl: 'डच्',
    noSearchLang: 'भाषा समर्थित नहीं',
    nso: 'सेसोथो सा लेबोअ',
    nya: 'न्यान्ज',
    or: 'ओडिया',
    otq: 'क्वेरेतारो ओटोमी',
    pa: 'पंजाबी',
    pl: 'पोलिश',
    placeholder: 'अन्वेषण',
    prs: 'दारि',
    ps: 'पाश्तो',
    pt: 'पोर्तुगाली (ब्राजील)',
    ptPT: 'पोर्तुगाली (पोर्तुगाल)',
    ro: 'रोमानियन्',
    ru: 'रूसी',
    run: 'रुण्डी',
    rw: 'किन्यार्वांडा',
    sd: 'सिन्धी',
    si: 'सिन्हल',
    sk: 'स्लोवाक',
    sl: 'स्लोवेनियाई',
    sm: 'सामोआन',
    sn: 'शोन',
    so: 'सोमाली',
    sq: 'अल्बानियाई',
    srCyrl: 'सर्बियाई (सिरिलिक)',
    srLatn: 'सर्बियन (लैटिन)',
    st: 'सेसोथो',
    sv: 'स्वीडिश',
    sw: 'स्वाहिली',
    ta: 'तमिल',
    te: 'तेलुगु',
    th: 'थाई',
    ti: 'तिग्रिन्य',
    tk: 'तुर्कमेन',
    tlhLatn: 'क्लिंगन्',
    tlhPiqd: 'क्लिंगन (पिकाड)',
    tn: 'सेत्सवाना',
    to: 'टोंगन',
    tr: 'तुर्की',
    tt: 'तातार',
    ty: 'ताहितीय',
    ug: 'उय्घुर',
    uk: 'ਯੂਕਰੇਨੀ',
    ur: 'उर्दू',
    uz: 'उज़्बेक (लैटिन)',
    vi: 'वियतनामी',
    xh: 'झोसा',
    yo: 'योरुबा',
    yua: 'युकाटेक माया',
    yue: 'कान्टोनीज़ (परम्परागत)',
    zh: 'चीनी',
    zhHans: 'चीनी सरलीकृत',
    zhHant: 'चीनी परंपरागत',
    zu: 'जूलु',
  },
  login: {
    and: 'च',
    btn: 'गूगलम् सह लॉग इन करोतु',
    btn1: 'अभी लॉग इन करें',
    desc: 'अधिक अनुभवान् अनलॉक् करणाय लॉग इन् कुरु',
    policy: 'गोपनीयता नीति',
    terms: 'प्रयोग शर्तें',
    tips: 'साइन अप करके, मैं सहमत हूं कि',
    title: 'नोमम् आगत्य स्वागतम्',
  },
  pageFooter: {
    follow: { facebook: 'फेसबुक', title: 'अनुज्ञात', twitter: 'ट्विटर' },
    legal: { policy: 'गोपनीयता नीति', terms: 'सेवा के नियम', title: 'वैधिक' },
    product: {
      image: 'प्रतिमा अनुवाद',
      pdf: 'पीडीएफ अनुवाद',
      title: 'उत्पादानि',
      video: 'वीडियो अनुवादः च सारांशः',
      web: 'वेब अनुवादः तथा सारांशः',
    },
    resources: { title: 'साधनानि' },
    tools: { title: 'यन्त्राणि', pdf: 'पीडीएफ अनुवाद' },
  },
  pageHeader: {
    contact: 'संपर्क',
    help: 'आर्य',
    logout: 'लॉग आउट',
    logoutSucc: 'लॉग आउट किया गया।',
    pricing: 'मूल्यन',
    settings: 'सेटिंग्स',
    signUp: 'प्रवेश करें',
  },
  pdf: {
    autoDetect: 'स्वतः-अन्वेषण',
    cancelBtn: 'अस्थापय',
    cancelUpload: 'अभीष्टं न करणीयते',
    chatPdf: {
      summaryError: 'सारांश असफल रहा, कृपया पश्चात् पुनः प्रयास कीजिए',
      chatError: 'चैट असफल रही, कृपया पश्चात् पुनः प्रयत्न कुरु',
      Search: 'अन्वेषणम्',
      cancel: 'अभीष्टम् वापयतु',
      chatTitle: 'नोमम् अहिला स्वागतम्! एतत् तव पीडीएफस्य सारसंग्रहः अस्ति:',
      clear: 'प्रखर (Prakhara)',
      clearContent:
        'एतत् नवं संभाषणं आरभयिष्यति। वर्तमानं संभाषणं न संरक्षितं भविष्यति। किं त्वं निश्चितः असि?',
      clearDialogTitle: 'कृपया पुष्टीकरणं कुरु',
      clearSucc: 'प्रमाणितः',
      copy: 'अनुलिपि',
      copySucc: 'अनुलिप्तम्',
      delete: 'महा (Maha)',
      deleteCancel: 'अभीष्टम् वापस लेना',
      deleteContent: 'एतत् पीडीएफ् संहृते पुनः प्राप्तुं न शक्यते। किं त्वं निश्चितः असि?',
      deleteOk: 'महा',
      deleteSuccess: 'मिटा दिया गया',
      deleteTitle: 'मिटाने की पुष्टि करें',
      expand: 'पदपात',
      historyTitle: 'इतिहास',
      listError:
        'पठन-सूची लोड करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
      loading: 'लोड हो रहा है...',
      noDataDesc: 'अद्यापि इतिहासः नास्ति',
      noMore: 'अधिकं सामग्री नास्ति',
      placeholder: 'इस पीडीएफ के विषय में कोई भी प्रश्न पूछें',
      summaryTitle: 'एषु प्रश्नेषु त्वं रुचाम् अस्ति वा: ',
    },
    collectionEmpty: 'तव संग्रहः शून्यः अस्ति',
    collectionTab: 'नोट्स',
    dataLoading: 'लोड हो रहा है...',
    dialogContent: 'किम् त्वं इदं मिटाना चाहathi स्पष्टम्?',
    dialogTitle: 'कृपया पुष्टि कुरु',
    download: {
      both: 'द्विभाषिक',
      btn: 'रक्ष',
      cancel:
        'इस विंडो को बंद करने से पीडीएफ डाउनलोड रद्द हो जाएगा। क्या आप वाकई इसे रद्द करना चाहते हैं?',
      desc: 'डिवाइस में सहेजें: अनुवादों को छवियों के रूप में डाउनलोड करता है; सहेजें और प्रिंट करें: मूल प्रारूप में अनुवादों को डाउनलोड करता है, जिसमें प्रतिलिपि समर्थन है।',
      download: 'डाउनलोड',
      downloadMsg1: 'पीडीएफ अनुवाद प्रगतिः:',
      downloadMsg2: 'अनुमानित शेष समयः',
      downloadSucc: 'पीडीएफ तैयार! सहेजने के लिए क्लिक करें।',
      downloadTip:
        'पीडीएफ डाउनलोड हो रहा है। डाउनलोड त्रुटियों से बचने के लिए इस विंडो को बंद न करें।',
      error: 'सहेजने में असफल। इसके बजाय प्रिंट करने का प्रयास करें।',
      fileName: 'फ़ाइल नामः',
      fileType: 'फाइल प्रकारः',
      loading: 'संचयं क्रियते...',
      loading2: 'लोड हो रहा है...',
      minute: 'मिनटे...',
      msg1: 'अस्मिन् दस्तावलये केचित् अनुवादाः मूलपाठस्य अधिकाः सन्ति, तथा डाउनलोड कृते फाइले अन्तः सङ्क्रमणं भवितुम् अर्हति। वेबपृष्ठे पठitum् सिफारिशं करामः।',
      msg2: 'अनुवाद अभी पूर्ण नहीं हुआ। अनुवाद समाप्त होने के पश्चात् कृपया डाउनलोड करें।',
      msg3: '२. केचित् अनुवादाः अत्यधिक दीर्घाः सन्ति। पृष्ठे पठत यतः पाठस्य सङ्क्रमणं निवर्तयेत्।',
      msg4: 'अनुवाद कार्यं संपाद्यते । तेषां समाप्त्यानन्तरं पुनः प्रयत्नं कुरु ।',
      progress:
        'पीडीएफं अनुवाद्यते। प्रगतिः: {{progress}}, अपेक्षित शेषकालः: {{minutes}} मिनटाः...',
      save: 'यन्त्राय संचयित्वा',
      savePrint: 'सहेजें और मुद्रित करें',
      success: 'डाउनलोड किया गया',
      trans: 'अनुवादमात्र',
      transContinue: 'अनुवादं प्रचरयतु',
    },
    downloadBtn: 'डाउनलोड',
    dragTipModal: {
      black: 'आकाश',
      leftKey: 'वाम बटन',
      ok: 'समझा',
      press: 'प्रेस्',
      tips: 'अनुमीलयित्वा पश्यतु',
    },
    entry: 'पीडीएफ्',
    fileErrMsg:
      'फाइल पठनं असफलं भवति। कृपया पश्चात् पुनः प्रयत्नं करोतु, या सहायतायै संपर्कं करोतु।',
    fileMsg: 'वर्तमान फ़ाइल आकारः',
    fileMsg2: 'कृपया 300MB से छोटी फ़ाइल अपलोड करें।',
    freeBannerBtn: 'उन्नति',
    freeBannerTips: 'मुफ्त पीडीएफ अनुवाद सीमा प्राप्त',
    guide: {
      placeholder: 'पीडीएफ लिंक यहाँ पेस्ट करें',
      start: 'अनुवाद प्रारम्भ कीजिए',
      text1: 'द्विभाषिक पठनम्',
      text2: 'मूलपाठं च अनुवादं च समक्षे समीकर्तुं द्विभाषया पठत, त्वच्छक्तिम् वृद्धयति।',
      text3: 'यस्याः पीडीएफस्य संगतिं करोतु',
      text4:
        'एआई-संचालित विश्लेषणं तथा सारांशनम्। तव पीडीएफस्य विषये प्रश्नाः पृच्छ, तत्क्षणान् उत्तराणि प्राप्स्यसि।',
      text5: 'सूक्ष्मं च कुशलं च',
      text6: 'अधिक शुद्धता और दक्षता के लिए एआई-संचालित पीडीएफ अनुवादः',
      title1: 'द्विभाषिक अनुवादः',
      title2: 'स्वयंपीडीएफं संभाषणम् करोतु',
      toast: 'कृपया .pdf से समाप्त होने वाला वैध ऑनलाइन पीडीएफ लिंक दर्ज करें',
    },
    hasTransTask: 'अनुवादकार्यं प्रचलति। कृपया प्रतीक्षा कुरु।',
    hoverTrans: 'परिच्छेदान् होवर करके अनुवाद्यत',
    initial: 'पीडीएफ अनुवाद कीजिए',
    installText: 'प्रतिदिनस्य अनुवादानां यत्नसहस्राणां एकस्थाने समाधानम्।',
    installText2: 'प्रथमतः विस्तारणं स्थापयतु',
    installTips:
      'adhikāṃ PDF anuvādaṃ ca, śīghraṃ ca vebsayaṭa anuvādaṃ labhetu: prakāriṇaṃ āsādhātu',
    kw: 'प्रधान',
    link: 'लिंक',
    listError:
      'पीडीएफ फ़ाइलें लोड करने में विफल। कृपया बाद में पुनः प्रयास करें या सहायता सेवा से संपर्क करें।',
    memoTotalCount: 'एकम् वस्तु सम्पूर्णम्',
    new: 'नवीनः फाइलः',
    noId: 'फाइल आईडी न प्राप्तः।',
    notPdf: 'पीडीएफ फाइलें मात्र',
    okBtn: 'मिटाना',
    okBtn2: 'अस्तु',
    original:
      'त्वं अत्यन्त सूक्ष्मं च विश्वसनीयं च आर्टिफिशियल इन्टेलिजेंस ह्यस्ति, यः विशिष्ट JSON स्कीमामध्ये पूर्णतया अनुरूप JSON आउटपुट उत्पन्न करने के लिए अभिकल्पितः।\n\nत्वं इमान् नियमान् अनुसरणीयः:\n1. JSON स्कीमा संरचनाम् कड़ाईपूर्वक अनुपालन कुरु।\n2. सर्वाणि डेटा प्रकारानि, आवश्यक क्षेत्राणि, च प्रतिबंधानि सटीकतया मेलय।\n3. अतिरिक्त पाठं, व्याख्यानं, मार्कडाउनं वा टिप्पणीन् न देव।\n4. JSON ऑब्जेक्टमात्रं आउटपुट कुरु — कोई कोड ब्लॉक न, कोई प्रारम्भिक वचन न, कोई आवरण न।\n\nस्कीमा सूचना निम्नवत् प्रदत्ता:\n- स्कीमा नामः translate_result\n- JSON स्कीमा:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'समानान्तर',
    parseErrDialogContent:
      'इयं पीडीएफ लिंकः प्रत्यक्षं अनुवादितुं न शक्यते। कृपया पीडीएफ डाउनलोड कृत्वा अनुवादाय अपलोड कुरु।',
    parseErrTips: 'फाइल पार्स करने में असफल',
    parseFileToast:
      'फाइल पार्स करने में असफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    pdfLoading: 'पार्सिंग...',
    searchPlaceholder: 'अन्वेषण',
    selectTrans: 'अनुवाद के लिए पाठ चुनें',
    shareBtn: 'विभाज्य',
    shareBtnText1: 'साझा लिंक उत्पन्न करें',
    shareBtnText2: 'साझितं सामग्रीपरिवर्तयतु',
    shareModal: {
      cancel: 'अस्थापयति',
      copy: 'अनुलिपिः',
      copySucc: 'लिंकः प्रतिलिपितः',
      custom: 'स्वयंरचित करना',
      errMsg: 'चयनितं सामग्रीः अभी पूर्णतया अनुवादिता नास्ति। साझा करने पूर्वं कृपया अनुवादयतु।',
      gen: 'विभाज्य',
      modify: 'संपादयति',
      notSupport: 'अस्य भाषायाः वर्तमाने समर्थनं नास्ति',
      page: 'पृष्ठानि',
      pageNuErr: 'यथार्थ पृष्ठ संख्या दर्ज़ कीजिए।',
      range: 'विषयक्षेत्रः',
      remain: 'शेष',
      remain1: 'कुल अनुमानित समय:',
      search: 'अन्वेषणम्',
      settings: 'साझा सेटिंग्सः',
      shareSetting: 'साझा सेटिंग्स',
      shareText: 'विभाज्य',
      shareTips: 'अनुवादित पीडीएफ लिंकं त्वया मित्रेभ्यः साझयताम्:',
      sourceLang: 'अस्मात्:',
      target: 'अनु:',
      text1: 'साझा सेटिंग्स',
      text2: 'साझा लिंक उत्पन्न करें',
      totalPage: 'एकं पृष्ठं कुलम्',
      trans: 'अनुवाद',
      translateTips:
        'सुझावः यदि अनुवादं लम्बं लेति, त्वं इयं विंडोः समापयित्वा पश्चात् साझा कर्तुम् शक्यसि।',
      translating: 'पीडीएफ अनुवादित हो रहा है...',
      update: 'साझा लिंक अपडेट करें',
    },
    shareMsg1: 'साझा लिंक उत्पन्न किया गया।',
    shareMsg2: 'साझितं सामग्री अद्यतितं।',
    shareMsg3:
      'साझा लिंक उत्पन्न करने में असफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    shareMsg4:
      'साझित सामग्री अपडेट करने में असफल रहा। कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    shareTips: 'तव पीडीएफ अनुवादः तैयारः अस्ति! तद् मित्रैः सह विभाजय।',
    start: 'अपना मुफ्त परीक्षण प्रारंभ करें',
    thumbnail: 'प्रस्तावना-सूची',
    toast1: 'पीडीएफ लोड हो रहा है। कृपया बाद में पुनः प्रयास करें।',
    toast2: 'पीडीएफ सामग्री प्रसंस्कृत की जा रही है। संवाद वर्तमान में असमर्थित है।',
    toast3: 'डाउनलोड हो रहा है। डाउनलोड समाप्त होने के बाद पुनः प्रयास करें।',
    toolbar: { Adjust: 'समायोजयति', autoFit: 'स्वतः-अनुकूलनम्' },
    trans: 'अनुवाद',
    transSucc: 'अनुवादः सफलः!्',
    unLoginToast: 'इस सुविधा का उपयोग करने के लिए कृपया लॉग इन करें।',
    uploadBtn: 'अपलोड्',
    uploadErr: 'फाइल अपलोड विफल रहा। कृपया पश्चात् पुनः प्रयास कुरु, या समर्थनम् संपर्क कुरु।',
    uploadErrSignUrl:
      'अपलोड यूआरएल प्राप्त करने में असफल। कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    uploadMsg1: 'अस्मिन् स्थाने तव फाइलं खींचकर ड्राप् कुरु',
    uploadMsg2: 'समर्थित फ़ाइल प्रकारः पीडीएफ्  |  अधिकतम फ़ाइल आकारः ३०० एमबी',
    uploadMsg3: 'यहाँ फ़ाइलों का चयन करने के लिए क्लिक करें या ड्रैग एंड ड्रॉप करें।',
    uploading: 'अपलोडीकरणम्',
    uploadingMsg: 'अपलोड हो रहा है। कृपया प्रतीक्षा कीजिए।',
    uploadingMsg1: 'फाइल अपलोड हो रही है। कृपया बाद में पुनः प्रयास करें।',
    uploadingMsg2: 'एकः फाइलः वर्तमानम् अपच्छाद्यते । कृपया पश्चात् पुनः प्रयत्नं कुरु ।',
    uploadingMsg3:
      'परिवर्तन प्रगति अनुरोध असफल हुआ। कृपया पश्चात् पुनः प्रयास करें, या सहायता से संपर्क करें।',
    uploadingMsg4:
      'नोमः स्थानिकान् फाइलान् प्राप्तुं न शक्नोति। अनुवादायै कृपया मैन्युअलतया पीडीएफ अपलोड कुरुत।',
    uploadingMsg5:
      'फाइल यूआरएल प्राप्त करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    video: 'वीडियो',
    vipBannerBtn: 'उन्नतिः',
    vipBannerTips: 'एतस्य मासस्य पीडीएफ अनुवाद सीमा त्वं प्राप्तवान्।',
    webTrans: 'पूर्ण परस्पर सन्दर्भ',
  },
  pricing: {
    FAQ: 'अक्सर पूछे जाने वाले प्रश्न',
    FQAObj: {
      a1: 'अस्तु, नोम् एकं मुफ्तम् योजनाम् प्रददाति यत् त्वं तत्कालमेव प्रयोजयितुम् शक्यसे।',
      a2: 'त्रीणि सदस्यत्व योजनानि प्रदायामः: प्रो, प्रो+, तथा एन्टरप्राइज़्। मासिकं वा वार्षिकं च भुगतानं चयitum् शक्नोषि। वार्षिकं बिलिंगं महतीं बचतीं प्रददाति।',
      a3: 'सर्वे लक्षणे दोनों योजनाओं में उपलब्धाः सन्ति। मुख्य भेदः लागता अस्ति: वार्षिक सदस्यताएँ सम्पूर्णतया कम लागतं अर्जयन्ति। मासिक सदस्यताएँ प्रतिमासं बिल की जाती हैं, जबकि वार्षिक योजनाएँ प्रतिवर्षं एक बार बिल की जाती हैं।',
      a4: 'अपनी सदस्यता को आप कभी भी अपनी खाता सेटिंग्स में रद्द कर सकते हैं।',
      q1: 'किं किञ्चित् मुक्तं योजना अस्ति?',
      q2: 'के दाम योजनाः और भुगतान विकल्पाः उपलब्धाः सन्ति?',
      q3: 'मासिकं च वार्षिकं च सदस्यत्वेन गृहणे कः भेदः अस्ति?',
      q4: 'मम सदस्यत्वं कथं निष्कासयामि?',
    },
    around: 'परिवर्तमान',
    billedMonthly: 'मासिकं बिल किया जाता है',
    billedYearly: 'वर्षावधि चरणम्',
    day: 'दिनम्',
    desc: 'योजनाः परिक्षयत यथासाधुतमं च चिनुत',
    detailedCompare: 'योजनाओं की तुलना कीजिए',
    discount: 'पच्चीस प्रतिशत छूट',
    enterprise: {
      benefit1: 'प्राथमिक ग्राहक सहायता',
      benefit2: 'अनेक उपयोगकर्ता',
      benefit3: 'अनुरूप समाधानाः',
      benefit5: 'नियत खाता प्रबंधक',
      btn: 'आमच्यासोबत संपर्क साधा',
      recommendText: 'स्वतन्त्र योजनाएँ (≥3 व्यक्ति)',
      talkToUs: 'संपर्क करें',
    },
    free: {
      benefit1: 'तत्क्षणे अनुवादः दिने शतं वारम्',
      benefit2: 'वेबसाइट अनुवादः च सारांशः',
      benefit3: '३० प्रतिमा अनुवादाः',
      benefit4: 'वीडियो अनुवादः तथा सारांशः',
      benefit5: 'दश पीडीएफ अनुवादाः',
      benefit6: 'पञ्च सहस्राणि टोकन',
      btn: 'मुफ्तमया प्रयत्न करोतु',
      recommendText: 'मुफ्त परीक्षण',
    },
    imageTranslation: 'प्रतिमा अनुवादः',
    month: 'मासः',
    monthly: 'मासिकम्',
    pageTitle: 'मूल्यनिर्धारणम्',
    pdf: {
      chat: 'पीडीएफ चैट प्रश्नावलिः',
      maxPage: 'प्रति पीडीएफ अधिकतम पृष्ठाः',
      translation: 'पीडीएफ अनुवाद',
    },
    preMonth: 'मासिकम्',
    pro: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: 'एकमिलियन टोकन/मासम्',
      benefit3: 'वेबसाइट अनुवादः तथा सारांशः',
      benefit4: 'द्विशत चित्रानुवादाः',
      benefit5: 'वीडियो अनुवादः तथा सारांशः',
      benefit6: '२०० पीडीएफ अनुवादाः',
      btn: 'आरंभ करें',
      recommendText: 'सर्वाधिक प्रसिद्ध',
    },
    proPlus: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: 'त्रिशतम् लाखं टोकेनप्रतिमासम् (Triśatam lākhaṃ ṭōkēnapratimāsam)',
      benefit3: 'वेबसाइट अनुवादः तथा सारांशः',
      benefit4: 'पञ्चशत चित्रानुवादाः',
      benefit5: 'वीडियो अनुवादः तथा सारांशः',
      benefit6: 'पीडीएफ अनुवादानां ५००',
      recommendText: 'उत्तम मूल्य',
    },
    video: { summary: 'वीडियो सारांशः', translation: 'वीडियो अनुवादः' },
    web: {
      contrastiveTranslation: 'द्विभाषी अनुवादः',
      dictionaryTranslation: 'चयनानुवादः',
      hoverTranslation: 'होवर अनुवादः',
      instantTranslation: 'तत्कालानुवादः',
      summary: 'वेब पृष्ठ सारांशः',
    },
    yearly: 'वर्षिकः',
  },
  privacy: {
    block1:
      'नोम ("नोम," "अस्मद्," "अस्माकम्" अथवा "अस्मान्") तव गोपनीयताम् आदरति स्म स च त्वयि अथवा तव परिष्कृतस्य कस्यचित् ज्ञानस्य रक्षणाय प्रतिबद्धः स्म। एषः गोपनीयता नियमः (Privacy Policy) निम्नानि प्रचाराणि वर्णयति यानि तव द्वारा अस्माकं वेबसाइटः, अनुप्रयोगाः, सेवाः (समूहतः "सेवाः") उपयुज्यमानानां सन्दर्भे व्यक्तिगतं ज्ञानं सङ्गृह्य वा उपयुज्य वा। एषः गोपनीयता नियमः (Privacy Policy) अस्माकं व्यावसायिक उत्पाद ग्राहकानाम् अर्थम् संवह्यमानस्य सामग्र्याः लागू न भवति, यथा अस्माकं API। एतस्य ज्ञानस्य उपयोगः अस्माकं ग्राहक समझौते (customer agreement) अधीनः अस्ति, यः एतान् उत्पादान् प्राप्तुं च उपयुज्य च समाविष्टः स्म।',
    block10:
      'अस्माभिः व्यापारिकदृष्ट्या युक्तानीतक, प्रबंधकीय, तथा संगठनात्मक उपायाः प्रयोज्याः सन्ति यतः ऑनलाइन तथा ऑफलाइन व्यक्तिगत सूचनाः हानि, दुरुपयोग, अनधिकृत प्रवेश, प्रकटीकरण, परिवर्तन, या शत्रुतापूर्ण क्रियाओं से संरक्षिताः भवन्ति। तथापि, कोई इंटरनेट या ईमेल प्रेषणं पूर्ण सुरक्षा या यथार्थता को गारंटी देने योग्य नास्ति। विशेषतया, अस्माभ्यं प्रेषिताः वा अस्माभ्यः प्रेषिताः ईमेलाः सुरक्षिताः न भवन्ति। तस्मात्, सेवा या ईमेल द्वारा अस्माभ्यं किम् सूचनां प्रेषितुं योजना कुर्वन्ति तदा विशेषतया सावधानाः भवितavyam्। अतिरिक्तम्, सेवा या तृतीय पक्ष वेबसाइटों के गोपनीयता सेटिंग्स या सुरक्षा उपायेषु किसी भी अवरोधस्य, अस्माभिः उत्तरदायित्वं नास्ति। तव व्यक्तिगत सूचनां, तव लिए सेवाः प्रदान करने या अन्य वैध व्यापारिक उद्देश्यान् (यथा विवाद समाधान, सुरक्षा और सुरक्षा कारणे, या कानूनी दायित्वानुसरणम्) के लिए आवश्यकसमयम् अवधारण करिष्यामः। व्यक्तिगत सूचनां कितने समय अवधारण करिष्यामः, तत् अनेक कारकैः निर्भरति, यथा सूचनायाः मात्रा, स्वभाव, संवेदनशीलता, अनधिकृत उपयोग या प्रकटीकरणस्य संभावित जोखिमाः, सूचनां प्रसंस्करणस्य उद्देश्याः, और अन्य कानूनी बाध्यकारी विचाराः।',
    block11:
      'एतं गोपनीयता नियमावलिम् कदाचिद् अपि अद्यतनयेमः। यदा एतत् करिष्यामः, तदा एतस्मिन् पृष्ठे अद्यतनीकृतं संस्करणम् प्रस्तुतयेमः, यदा न तु विधेयः कानीयः कानूनः अन्यथा अनिवार्यते।',
    block12:
      'यदि त्वं एतस्य गोपनीयता नीतितत्त्वे अनुत्तरितान्य प्रश्नान् वा चिन्ताशयान् अस्ति, कृपया आमच्या ग्राहक सेवेशः सम्पर्कं कर। इमेलः',
    block2:
      'अस्माभिः त्वयि सम्बन्धितं निम्नलिखितं व्यक्तिगतं ज्ञानम् ("व्यक्तिगतं ज्ञानम्") संगृह्यते:',
    block3:
      'यत् त्वया प्रदत्तं ज्ञानम्: यदा त्वं सेवामानं खातं निर्माणं कुर्वसि या वा आवाम् सह संवादं कुर्वसि, आवाम् त्वया प्रदत्तं व्यक्तिगतं ज्ञानम् इदं चिनोति:',
    block4:
      'सेवाओं के उपयोग से स्वचालित रूप से प्राप्त व्यक्तिगत सूचना: जब आप सेवाओं का उपयोग करते हैं, पहुँचते हैं या उनके साथ परस्पर क्रिया करते हैं, तो हम आपकी पहुँच, उपयोग या परस्पर क्रिया के बारे में निम्नलिखित सूचना प्राप्त करते हैं ("तकनीकी सूचना"):',
    block5: 'आत्मनिः श्रेयसकराणि विविधानि कार्याणि प्रयोजनानि च प्रयोगं कुर्मः यदि: ',
    block6:
      'सारांश या अवयव-विहीन सूचना: हम व्यक्तिगत सूचना को समेकित कर सकते हैं या अवयव-विहीन कर सकते हैं ताकि पहचान उद्देश्यों के लिए इसका पुन: उपयोग रोका जा सके और ऐसी सूचना का उपयोग हमारी सेवाओं की प्रभावशीलता का विश्लेषण करने, हमारी सेवाओं में सुधार करने और विशेषताएँ जोड़ने, अनुसंधान करने और इसी प्रकार के उद्देश्यों के लिए कर सकते हैं। इसके अतिरिक्त, हम अपनी सेवा के उपयोगकर्ताओं के सामान्य व्यवहार और विशेषताओं का विश्लेषण कर सकते हैं और समेकित सूचना को तृतीय पक्षों के साथ साझा कर सकते हैं, ऐसी समेकित सूचना को प्रकाशित कर सकते हैं या इसे सामान्य रूप से उपलब्ध करा सकते हैं। हम सेवाओं के माध्यम से, कुकीज़ के माध्यम से और इस गोपनीयता नीति में वर्णित अन्य माध्यमों के माध्यम से समेकित सूचना एकत्र कर सकते हैं। हम अवयव-विहीन सूचना को अनाम या अवयव-विहीन रूप में रखेंगे और उपयोग करेंगे, और कानून द्वारा आवश्यक नहीं होने तक हम ऐसी सूचना को पुन: पहचानने का प्रयास नहीं करेंगे।',
    block7:
      'केचन स्थितिषु, यदि न कानूनेन व्यवस्थितमस्ति, तत्र तव व्यक्तिगतं ज्ञानं तृतीयपक्षेभ्यः तव बिना आगतसूचनया प्रदानं करिष्यामः:',
    block8:
      'यour geographic location (यौहनस्य भौगोलिक स्थानानुसार), यूरोपियन इकोनॉमिक एरिया (यूरोपीय आर्थिक क्षेत्र), यूनाइटेड किंगडम (यूनाइटेड किंगडम) तथा विश्वव्यापी स्थानेषु स्थितः पुरुषः (व्यक्ति) तस्य स्वयं के व्यक्तिगत जानकारी (व्यक्तिगत सूचना) सम्बन्धे कतिपय वैधानिक अधिकारान् (कानूनी अधिकार) अस्ति (प्राप्त कर सकता है)। उदाहरणार्थ (उदाहरण के लिए), यौहनस्य अधिकारः अस्ति (आपके पास अधिकार हो सकता है):',
    block9:
      'एतत् सेवा नोआम द्वारा संचालितं या नियंत्रितं न भवतीत्यर्थान् अन्यान् वेबसाइट्स्‌ (सामाजिक मीडिया सेवाओं सहित, "तृतीय-पक्ष वेबसाइट्स्") के लिंक्स्‌ समाविष्टं कर्तुं शक्यते। तृतीय-पक्ष वेबसाइट्स्‌ के साथ यदि त्वं सूचनां साझां करोषि, तदा तस्या सूचनायाः नियमनं एतस्य प्राइवेसी पॉलिसी द्वारा न भविष्यति, अपितु तृतीय-पक्ष वेबसाइट्स्‌ के विशिष्ट प्राइवेसी पॉलिसी तथा सेवा शर्ता द्वारा। एतान् लिंक्स्‌ आवश्यकतानुसार प्रदानं कुर्मः, तथा एतस्या वेबसाइट्स्‌ के प्रति आराधना वा समीक्षा का संकेतं न ददामः। तेषां प्राइवेसी पॉलिसी तथा शर्ता सम्बन्धी जानकार्यarthasya, कृपया तृतीय-पक्ष वेबसाइट्स्‌ को प्रत्यक्षं सम्प्रेषयतु।',
    subBlock1:
      'खाता सूचना: यदि त्वं स्वयं को आम्हारस्य प्लेटफॉर्मे खातं निर्माण करति, आम्हे तव खातस्य सम्बन्धित सूचना संगृह्यते, तस्याम् तव नाम, संपर्क सूचना, खाता प्रमाणिकरण, भुगतान कार्ड सूचना तथा लेन-देन इतिहास ("खाता सूचना") समाविष्टः।',
    subBlock10: 'सेवाओं का प्रदान करना, प्रबंधन करना, रखरखाव करना और/या विश्लेषण करना;',
    subBlock11: 'त्वया संवादं करोति',
    subBlock12: 'नवानि उत्पादानि च सेवाः विकस्यन्ति;',
    subBlock13:
      'अपहरणं, अपराधकारित्वं वा सेवाणाम् अव्यावहारिक उपयोगं रोकनं, तथा आमस्या आयटी प्रणालियों, संरचना वा नेटवर्क्स सुरक्षा रक्षणं;',
    subBlock14: 'व्यापारस्थानान्तरं करोति',
    subBlock15:
      'वैधानिक कर्तव्यानि च वैधानिक क्रियाकलापानि च अनुपालनं कुर्वन्ति, स्वाङ्गं अधिकारान्, गोपनीयताम्, सुरक्षाम्, वा धनसंपत्तिं रक्षन्ति, साथैव स्वेषां सहयोगिनाम्, त्वां वा अन्यानां तृतीयपक्षाणाम् अपि।',
    subBlock16:
      'प्रदाता:और सेवा प्रदाता:ः व्यावसायिक कार्यान्वय आवश्यकताओं को पूरा करने और कुछ सेवाओं तथा कार्यों को प्रदान करने में हमारी सहायता करने के लिए, हम व्यक्तिगत सूचना प्रदाताओं और सेवा प्रदाताओं को प्रदान कर सकते हैं, जिनमें होस्टिंग सेवा प्रदाता, क्लाउड सेवा प्रदाता, अन्य सूचना प्रौद्योगिकी सेवा प्रदाता, ईमेल संचार सॉफ्टवेयर, और वेब विश्लेषण सेवा प्रदाता आदि शामिल हैं। ये साझेदार केवल हमारे निर्देशनानुसार हमारे लिए कर्तव्य प्रदर्शन करते समय व्यक्तिगत सूचना에 접근 करेंगे, प्रक्रिया करेंगे या संग्रह करेंगे।',
    subBlock17:
      'व्यापार हस्तांतरणम्: यदि अहम् रणनीतिकाः लेनदेनाः, पुनर्गठनानि, दिवालियत्वानि, दिवालियत्वग्रहणानि, अथवा सेवाः अन्ये प्रदात्रा को स्थानान्तरं करति (समग्रं यथा "लेनदेनानि"), तदा तव व्यक्तिगतं ज्ञानं च अन्यं च ज्ञानं लेनदेनसहभागिनः सहैव लेनदेनेषु सहायता करने वालेभ्यः पक्षेभ्यः देय्यम्, तत्पर्येण च लेनदेनेषु अङ्गीकृतम्, अन्यैः संपत्तिभिः सहैव उत्तराधिकारिणे अथवा सहयोगी कम्पन्यायाः हस्तान्तरितम्।',
    subBlock18:
      'कानूनी आवश्यकताः तव व्यक्तिगत सूचनां प्रशासकीय प्राधिकारियों, उद्योग सहकर्मियों, या अन्य तृतीय पक्षों के साथ साझा कर सकतः, तव सेवाओं के साथ संपर्क सूचना सहित, (1) यदि कानून द्वारा आवश्यक या यदि कानूनी दायित्वों का पालन करने के लिए ऐसा कार्य आवश्यक समझतः; (2) अपेक्षित अधिकारों या संपत्ति की रक्षा और रक्षा के लिए; (3) यदि स्वयं निर्णय करतः कि तार्खों, नीतियों या कानूनों का उल्लंघन हुआ है; (4) धोखा या अन्य अवैध गतिविधियों का पता लगाने या रोकने के लिए; (5) अपेक्षित उत्पादों, कर्मचारियों, या उपयोगकर्ताओं, या सार्वजनिक सुरक्षा, सुरक्षा, अखंडता की रक्षा के लिए; या (vi) कानूनी दायित्व से बचने के लिए।',
    subBlock19:
      'स्वयं की व्यक्तिगत सूचना तथा यथा यथा तत् प्रक्रिया क्रियते तस्य विषये सूचना प्राप्तयति।',
    subBlock2:
      'यदि त्वं नः सेवासु प्रयुञ्जसे, ततः त्वया दत्तैः इनपुटैः, फाइल अपलोडैः वा प्रतिक्रियाभिः ("सामग्री") स्वयं प्राप्तैः व्यक्तिगतं ज्ञानं संकलयामः।',
    subBlock20: 'आपकस्य वैयक्तिकं ज्ञानं आमच्या अभिलेखातून हटवण्याची विनंती करोते।',
    subBlock21: 'स्वयं के व्यक्तिगत जानकारी का सुधारण या अद्यतन कीजिए।',
    subBlock22: 'स्वयं का व्यक्तिगत सूचना तृतीय पक्ष को स्थानान्तरित करें (डेटा पोर्टेबिलिटी)।',
    subBlock23: 'आपकस्य वैयक्तिक ज्ञानस्य प्रसंस्करणं कथम् करामः तत् सीमां कुरुत',
    subBlock24:
      'त्वं तुम्हारी सहमति वापस ले लो—जहां प्रसंस्करण के लिए कानूनी आधार के रूप में हम सहमति पर निर्भर करते हैं, तुम्हें किसी भी समय अपनी सहमति वापस लेने का अधिकार है।',
    subBlock25:
      'आपकस्यैव वैयक्तिकं ज्ञानं यथा प्रसंस्कर्मः कृतः अस्ति, तत् प्रति आपत्ति प्रस्तावयति।',
    subBlock26: 'asmākam sevāḥ vṛddhim āpadyantāṃ ca anusandhānaṃ carantāṃ ca',
    subBlock3:
      'संप्रेषण सूचना: यदि त्वं नः सन्देशान् प्रेष्यसि, तदा तव नाम, संपर्क सूचना तथा तव सन्देशानां सामग्री ("संप्रेषण सूचना") नः सङ्गृह्यते ।',
    subBlock4:
      'सोशल मीडिया सूचना: इंस्टाग्राम, फेसबुक, मीडियम, ट्विटर, यूट्यूब, तथा लिंक्डइन जैसै: सोशल मीडिया वेबसाइटों पर अस्माकं पृष्ठाः सन्ति। यदि त्वं अस्माकं सोशल मीडिया पृष्ठैः संपर्कम् करोषि, तदा त्वं यद् वैयक्तिकं सूचनं ददासि, यथा तव संपर्क विवरणानि ("सोशल सूचना"), तत् अस्माभिः सङ्गृह्यते। अतिरिक्तम्, ये कम्पनियः अस्माकं सोशल मीडिया पृष्ठानि आयोजयन्ति, ते अस्माभिः सोशल मीडिया गतिविधियों संबंधे सङ्कलितं सूचनं तथा विश्लेषणं प्रदान कर्तुं शक्नन्ति।',
    subBlock5:
      'लोग डेटा: हमारी सेवाओं का उपयोग करते समय आपके ब्राउज़र द्वारा स्वचालित रूप से भेजी गई जानकारी। लोग डेटा में आपका इंटरनेट प्रोटोकॉल (आईपी) पता, ब्राउज़र प्रकार और सेटिंग्स, आपके अनुरोधों की तारीख और समय, और आप हमारी वेबसाइट के साथ कैसे संपर्क करते हैं शामिल है।',
    subBlock6:
      'उपयोग डेटा: सेवा के उपयोग के बारे में हम स्वचालित रूप से जानकारी एकत्र कर सकते हैं, जैसे कि आप किस प्रकार की सामग्री देखते हैं या与之 परस्पर क्रिया करते हैं, आप कौन सी सुविधाएँ उपयोग करते हैं, आप कौन सी क्रियाएँ करते हैं, साथ ही आपका समय क्षेत्र, देश, पहुँच की तिथि और समय, उपयोगकर्ता एजेंट और संस्करण, कंप्यूटर या मोबाइल डिवाइस प्रकार, और आपका कंप्यूटर कनेक्शन।',
    subBlock7:
      'यन्त्र सूचना: एतत् यन्त्रस्य नाम, परिचालन प्रणाली, यन्त्र पहिचानकर्ता, तथा त्वया प्रयुक्त ब्राउजर समाविष्टम् अस्ति। सङ्गृहीत सूचना त्वया प्रयुक्त यन्त्रस्य प्रकारं तथा तस्य सेटिंग्सम् निर्भरति।',
    subBlock8:
      'कुकीजः (Cookies): सेवाओं को संचालित करने और प्रबंधित करने के लिए तथा आपके अनुभव को सुधारने के लिए हम कुकीज़ का उपयोग करते हैं। "कुकी" वह सूचना है जो आप देख रहे वेबसाइट द्वारा आपके ब्राउज़र को भेजी जाती है। आप अपने ब्राउज़र को सभी कुकीज़ स्वीकार करने के लिए, सभी कुकीज़ अस्वीकार करने के लिए, या जब कोई कुकी प्रदान की जाती है तो आपको सूचित करने के लिए सेट कर सकते हैं ताकि आप हर बार यह निर्णय ले सकें कि उसे स्वीकार करें या नहीं। हालांकि, कुकीज़ को अस्वीकार करने से आप वेबसाइट के कुछ क्षेत्रों या सुविधाओं का उपयोग करने से रोका जा सकता है या उनके प्रदर्शन या कार्यक्षमता पर नकारात्मक प्रभाव पड़ सकता है। कुकीज़ के बारे में अधिक जानकारी के लिए, कृपया ऑल अबाउट कुकीज़ (All About Cookies) पर जाएं।',
    subBlock9:
      'विश्लेषणम्: अपि स्माकं विभिन्नानि ऑनलाइन विश्लेषण-उत्पादानानि उपयुज्यामः, यानि कुकीज् (cookies) प्रयुञ्जते यतः स्माकं मद्देन कस्मै प्रकारेण उपयोक्तारः सेवासु प्रयुञ्जन्ति तत् विश्लेष्टुम् च सेवासु प्रयोगं कर्तुम् अस्ति तव अनुभवं सुधारयितुम् च समर्थयन्ति।',
    subTitle1: 'आपसे प्राप्त व्यक्तिगत सूचना',
    subTitle2: 'आपणः वैयक्तिक ज्ञानं कथं प्रयुञ्जामः',
    subTitle3: 'आत्मन्यनिजस्य सूचनायाः प्रकटीकरणम्',
    subTitle4: 'तव अधिकाराः',
    subTitle5: 'अन्य वेबसाइटों के लिंक',
    subTitle6: 'जानकार्यस्य सुरक्षा च संरक्षणं च',
    subTitle7: 'गोपनीयता नीत्या: परिवर्तनम्',
    subTitle8: 'अस्माकं सम्पर्कं कथम् कर्तव्यम्',
    title: 'गोपनीयता नियमावलिः',
    updateTime: 'अद्यतनीकृतम्: मार्च १५, २०२४',
  },
  privacyCollectionPanel: {
    acceptBtn: 'सर्वं स्वीकरोतु',
    text: 'योः अनुभवं सुधारितुं, स्वयं कुकीज्-सह सामग्री व सेवाः वैयक्तिकीकृतुं उपयुज्यामः।',
    title: 'एतत् वेबसाइटम् कुकीहर् उपयोगयति',
  },
  slogen: 'आसानतमः एआई सहायकः',
  stripe: {
    contact: 'किन्हीं प्रश्नों के लिए contact@noam.tools पर हमसे संपर्क करें!',
    fail: {
      btn: 'पुनः प्रयत्नं करोतु',
      text1: 'आपके भुगतान को प्रसंस्कृत नहीं कर सके।',
      text2: 'स्वयं कनेक्शनं परीक्षयताम्। पुनश्च प्रयत्नं कुरूताम्।',
      title: 'भुगतानं असफलम्',
    },
    succ: { btn: 'गच्छामः', text1: 'नोमम् आगत्य स्वागतम्', text2: 'आरभयामः', title: 'अभिनन्दनम्' },
  },
  terms: {
    block1: 'नोमं प्रयोगं कृत्वा धन्यवादः!',
    block10:
      'शुल्कं और बिलिंगः। त्वं सम्बन्धित मूल्य पृष्ठे या आमदानी बीच लिखित रूपेण सहमत किए गए मूल्यानुसार सर्व शुल्कान् ("शुल्क") दास्यसि। यद्यपि आमदानी निर्गत किए गए या भुगतान प्राप्त किए गए, तथापि मूल्य त्रुटियों या त्रुटियों को सुधारने का अधिकार आमदानी स्वीकरोति। त्वं पूर्णं और यथार्थं बिलिंग सूचना, मान्यं और अधिकृतं भुगतान विधि सहित प्रदास्यसि। आमदानी तव भुगतान विधि को सहमत किए गए आवधिक आधार पर चार्ज करिष्यति, परन्तु आमदानी बिलिंग तिथि को युक्तिपूर्वक परिवर्तन कर सकति है। त्वं नोम, तस्य सहयोगियों, और तृतीय पक्ष भुगतान प्रोसेसरों को तव भुगतान विधि को चार्ज करने को अधिकृत करति है। यदि तव भुगतान विफल होति है, आमदानी तुभ्यम् लिखित सूचना प्रदास्यति और भुगतान प्राप्त होने तक सेवा की पहुँच को निलंबित कर सकति है। यदि अन्यथा इस समझौते में निर्दिष्ट न किया गया हो, तो भुगतान असन्तोषजनक हैं।',
    block11:
      'कराः। अन्यथा निर्दिष्ट न कृते तु, शुल्काणि कस्यचित् संघीय, राज्यीय, स्थानीय, तथा विदेशी करान्, कर्तव्यान्, तथा तद्भूतांशान् ("कराः") न समाविष्टि। त्वं त्वया क्रयस्य संबंधितान् सर्वान् करान् जिम्मे असि, येऽस्माकं शुद्ध-आयतन्त्र-आधारिताः कराः तान् व्यतिरिक्त्य, येषाम् अहम् ते निवेदनं दास्यामि। त्वं सहमति असि यत् त्वं तान् करान् शीघ्रं प्रদास्यसि, तथा अहमाकं वैधिक-वैधानिकं गोपनीयता-विवरणं प्रदास्यसि, तथा तद् डेटा संचालनाय संबंधितान् आवश्यकान् सहमतियान् प्राप्स्यसि, तथा त्वं प्रतिज्ञासि अहमाकं यत् त्वं तद् डेटा संबंधित कानूनानुसारं संचालयसि।',
    block12:
      '(ग) मूल्य परिवर्तनाः। त्वामहं तव खात्राधारम् एवम्/वा मम वेबसाइटम् द्वारा सूचित्य मूल्यानि परिवर्तयितुं शक्नोमि। मूल्य वृद्धयः पोस्ट किए जाने पर तत्कालैव प्रभावी भविष्यन्ति। कोई मूल्य परिवर्तन परिवर्तनस्य प्रभावी तिथेः पश्चात् तव खात्राधारस्य शुल्केभ्यः लागू होगा।',
    block13:
      'विवादाः च दीर्घकालीन परिशोधनानि च। यदि त्वं कस्यचित् शुल्कानाम् अथवा करानाम् विवादं कुर्वितुम् इच्छसि, तदा इन्वॉइस तिथेः त्रिंशद् (३०) दिनान्तरम् contact@noam.tools पत्रेषु सम्पर्कं करोतु।',
    block14:
      'मुक्त उपयोगः। मुक्त क्रेडिट्स प्राप्त करने के लिए तुम्हें अनेक खाते नहीं बना सकते। यदि हम निर्णय करते हैं कि तुम मुक्त क्रेडिट्स का सद्भावना से उपयोग नहीं कर रहे हो, तो हम तुम्हें मानक शुल्क लगा सकते हैं या सेवा तक पहुँच प्रदान करना बंद कर सकते हैं।',
    block15:
      'गोपनीयता. त्वं नोमच्या गोपनीय माहितीला प्रवेश प्राप्त करु शकसि. त्वं केवल या नियमानुसार परवानगी दिलेल्या प्रकारे सेवा वापरण्याच्या उद्देशासाठी गोपनीय माहिती वापरु शकसि. त्वं गोपनीय माहिती कोणत्याही तृतीय पक्षाला प्रकट करू नये, आणि त्वं स्वतःच्या समान गोपनीय माहितीचे संरक्षण करण्यापेक्षा कमी संरक्षण न करता गोपनीय माहितीचे संरक्षण करशील, किमान वाजवी काळजेने. गोपनीय माहिती ही नोम द्वारा गोपनीय म्हणून नियुक्त केलेली किंवा परिस्थितींनुसार वाजवीपणे गोपनीय मानली पाहिजे अशी गैर-सार्वजनिक माहिती आहे, ज्यामध्ये सॉफ्टवेअर, वैशिष्ट्ये आणि इतर गैर-सार्वजनिक व्यवसाय माहिती समाविष्ट आहेत. गोपनीय माहितीमध्ये खालील प्रकारची माहिती समाविष्ट नाही: (1) तुमच्या दोषाशिवाय सामान्यतः सार्वजनिकासाठी उपलब्ध होणारी; (2) या नियमांतर्गत प्राप्त करण्यापूर्वी तुमच्याकडे गोपनीयतेच्या कोणत्याही बंधनाशिवाय असलेली; (3) तृतीय पक्षाद्वारे तुम्हाला कोणत्याही गोपनीयता बंधनाशिवाय कायदेशीररित्या प्रकट केलेली; किंवा (4) तुम्ही गोपनीय माहिती वापरल्याशिवाय स्वतंत्रपणे विकसित केलेली माहिती. कायदा, न्यायालय किंवा इतर सरकारी आदेशामुळे आवश्यक असल्यास तुम्ही गोपनीय माहिती प्रकट करू शकता परंतु तुम्ही नोमला वाजवी प्रकारे पूर्व लिखित सूचना दिली पाहिजे आणि शक्य तितक्या प्रमाणात, प्रकटीकरणाची व्याप्ती मर्यादित करण्यासाठी वाजवी प्रयत्न करणे आवश्यक आहे, ज्यामध्ये प्रकटीकरण विनंत्यांना विरोध करण्यात आम्हाला मदत करणे समाविष्ट आहे.',
    block16:
      'सुरक्षा। सेवा के प्रयोग और पहुँच की रक्षा करने में मदद करने के लिए तुम्हें युक्तिसंगत और उपयुक्त उपाय करने चाहिए। यदि तुम्हें सेवा के प्रयोग से संबंधित कोई कमजोरियाँ या उल्लंघन पाए जाते हैं, तो तुम्हें तुरंत नोम को संपर्क करना चाहिए और कमजोरी या उल्लंघन का विवरण प्रदान करना चाहिए।',
    block17:
      '(ग) व्यक्तिगत डेटा प्रसंस्करणम्। यदि त्वं सेवां प्रयुङ्क्ते व्यक्तिगत डेटं प्रसंस्करणाय, त्वं कानूनिकरूपेण पर्याप्तं गोपनीयता विवरणं प्रदानं कुर्याः तथा तस्य डेटस्य प्रसंस्करणाय आवश्यकं सहमतिं प्राप्तं कुर्याः, तथा त्वं अस्मै आश्वासयति यत् त्वं तं डेटं लागू कानूनस्य अनुसार व्यवहारयसि।',
    block18:
      'निवृत्तिः; निलंबनम्। एतानि नियमानि सेवायाः तव प्रथमप्रयोगात् प्रभावी भविष्यन्ति तथा निवृत्ति: यावत् प्रभावी रमिष्यन्ति। त्वं किसी प्रयोजनार्थं कदाचित् सेवायाः तथा सामग्र्याः उपयोगं त्यज्यैतानि नियमानि निवर्तयितुमर्हसि। आवश्यकतानुसारेण पूर्वसूचनया अहमेतानि नियमानि निवर्तयितुं शक्नोमि। यदि त्वं धर्मदृष्ट्या अनुच्छेद २ (उपयोगापेक्षाएः), अनुच्छेद ५ (गोपनीयता, सुरक्षा, तथा डेटा संरक्षण), अनुच्छेद ८ (विवादसमाधान), या अनुच्छेद ९ (सामान्य नियमानि) भङ्कर्तुमर्हसि, या यदि मम संबंधः कस्यचित् तृतीय-पक्ष प्रौद्योगिकी प्रदाता: (यस्य नियंत्रणं नास्ति) बदलेति, या यदि कानूनं वा सरकारी अनुरोधानि अनुपालनीयानि स्युः, तदा अहम् त्वां सूचयित्वा तत्क्षणमेव एतानि नियमानि निवर्तयितुं शक्नोमि। यदि त्वं एतानि नियमानि पालनं न कुर्यासि, या यदि तव उपयोगः मयि वा कस्यचित् तृतीय-पक्षस्य सुरक्षा जोखिमं प्रदायितुं स्यात्, या यदि तव उपयोगः धोखाधड़ीभूतः अस्ति वा मयि वा कस्यचित् तृतीय-पक्षस्य दायित्वं प्रदायितुं स्यात् इति शङ्कयामि, तदा अहम् तव सेवायाः प्रवेशं निलंबयितुं शक्नोमि।',
    block19:
      'निवृत्तिकरणस्य प्रभावः। निवृत्तौ, त्वं सेवाम् उपयुञ्जितुम् त्यजेत् तथा यथा आरोपितं तत् गोपनीयं ज्ञानं त्वरितं प्रत्यर्पयेत् वा नष्टयेत्। ये तस्याः शपथस्य प्रावधानाः स्वाभाविकतया निवृत्ति वा समाप्तेः पश्चात् अपि अवशिष्टाः भवेयुः, यथा अनुभागः ३ तथा ५-९ पर्यन्तम्, ते अवशिष्टाः भविष्यन्ति।',
    block2:
      'एतानि उपयोग-नियमानि नोम-सेवासु तव उपयोगाय लागू भवन्ति, यानि एप्लिकेशन प्रोग्रामिंग इंटरफेस, सॉफ्टवेयर, उपकरणानि, डेवलपर सेवा, डेटा, दस्तावेजीकरण, च यथा वेबसाइट (यानि समूहेन "सेवाः" इति उच्यते). अस्माकं सेवासु उपयुज्यमानेन, त्वं एतानि नियमानि पालन करने सहमतः असि। अस्माकं गोपनीयता नीतिः कथयति किं प्रकारेण अहम् व्यक्तिगतं सूचनां संगृह्यति च प्रयुज्यति च।',
    block20:
      'रक्षावचनम्। त्वं अस्मान्, आमाश्रयकान् च, तथा आमान् कर्मचारिणः च, सर्वेभ्यः दावैः, हानिभ्यः, व्ययेभ्यः (वकीलोप fees सहित) अप्रतिहतान् रक्षिष्यसि, प्रतिक्षिप्स्यसि, संरक्षिष्यसि च, ये तव सेवाप्रयोगात् उत्पन्ना भवन्ति या तस्य सम्बन्धिनः, तव सामग्री समेतः, सेवाया सम्बन्धिनः उत्पादानाम् वा सेवानाम् तव प्रयोगः, तथा एतेषां शब्दानाम् वा विधिनम् तव उल्लङ्घनम्।',
    block21:
      '(b) निषिद्धकथनानि। सेवा "यथास्ति" प्रदायते। कानूनेन अनुमत限度मा, आवाम्, आवाम् सहयोगिनः च तथा लाइसेन्सरः सेवायाः संबंधे कस्यचित् प्रकारस्य प्रतिनिधित्वं वा वारणं न ददामः, तथा व्यापारिकत्वस्य, विशेष उद्देश्यार्थं योग्यत्वस्य, सन्तोषजनक गुणस्य, अव्याहतत्वस्य, शान्त उपभोगस्य, तथा व्यवहार क्रमस्य वा व्यापार प्रयोगस्य निमित्तं होने वाले किसी भी प्रकारस्य वारणं न ददामः। आवाम् सेवा अविच्छिन्ना, सच्चा, अथवा त्रुटिहीना भविष्यति, अथवा कोई सामग्री सुरक्षित, न हारित, अथवा न परिवर्तित भविष्यति इति वारणं न ददामः।',
    block22:
      '(ग) दायित्व की सीमा। न तो हम, न हमारे सहयोगी, न हमारे लाइसेंसर किसी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी या दंडात्मक क्षति के लिए उत्तरदायी होंगे, जिसमें लाभ की हानि, प्रतिष्ठा की हानि, उपयोग की हानि, डेटा की हानि या अन्य अमूर्त हानियां शामिल हैं, भले ही हमें ऐसी क्षतियों की संभावना के बारे में सलाह दी गई हो। इन शर्तों के तहत, हमारी कुल दायित्व उस शुल्क से अधिक नहीं होगी जो आपने दावे से पहले बारह (12) महीनों में सेवा को दिया है या एक सौ अमेरिकी डॉलर ($100), जो भी अधिक हो। इस खंड में दी गई सीमाएं लागू कानून द्वारा अनुमत अधिकतम सीमा तक लागू होती हैं।',
    block23:
      'ये नियमाः तथा सेवासेवनं यूएस कानूनैः नियंत्रितं भवति, यूएस कानूनसंघर्ष नियमान् अपवाद्यतः। अनुप्रयोगसेवनं त्वं स्थानिक, राज्य, राष्ट्रीय वा अन्तर्राष्ट्रीय कानूनेभ्यः अपि अधीनं भवितुं शक्यते। एतैः नियमैः सम्बन्धितं कोई भी कानूनी कार्यवाही या विचार-विमर्श यूएस कोर्ट्स में ही की जाएगी, और तुम् ऐसे न्यायालयों की व्यक्तिगत अधिकारित्वम् को स्वीकार्यामिति सहमति करते हो।',
    block24:
      'पक्षाणां संबंधः। नोआम् तथा त्वं स्वतंत्र कार्यदातारौ स्थिताः, अन्योन्यं प्रतिनिधित्व करने या बाध्य करने या दूसरे पक्ष के लिए दायित्वान् ग्रहण करने की शक्ति को न तुम्हारे न नोआम् को प्राप्तं, दूसरे पक्षस्य पूर्वकालिक लिखित स्वीकृति बिना।',
    block25:
      'ब्राण्ड उपयोगः। नोअमस्य वा तस्य किसी सहयोगी संस्थानस्य नामानि, लोगोस् वा ट्रेडमार्कानि आम्हारस्य पूर्वकालिक लिखित सहमति बिना त्वं उपयोजयितुम् न शक्यसे।',
    block26:
      'यदि एतेषां नियमाणां कोऽपि विधानं अवैधं, अन्यायिकं वा अनिर्वाह्यं सिद्ध्यति, तर्हि शेष विधानानि पूर्णबलेन प्रभावेन च स्थास्यन्ति।',
    block3:
      'यदि त्वं अष्टादश वर्षान् नाधिकः असि, त्वं सेवाम् उपयुज्येतुम् मातापितृणाम् वा कानूनिकान् अभिरक्षकान् वा अनुमतिं प्राप्तुं कर्तव्यम्। यदि त्वं कस्यचित् अन्यस्य व्यक्तेः वा संस्थानस्य प्रतिनिधित्वेन सेवाम् उपयुज्यसे, त्वं तेषां प्रतिनिधित्वेन एतान् शर्तान् स्वीकर्तुम् अधिकृतः अस्तीति आवश्यकम्। त्वं खातरं पंजीकृतुं सच्चं च पूर्णं च ज्ञानम् प्रदानम् कर्तव्यम्। त्वं तव प्रवेश-सञ्चिकाओं वा खातरं तव संगठनस्य बाह्ये कस्यचित् को न देयम्, तथा त्वं तव सञ्चिकाओं द्वारा कृताः सर्वाः क्रियाः कृते उत्तरदायी असि।',
    block4:
      'सेवा का उपयोग। तुम् इन शर्तों के अधीन सेवा का उपयोग कर सकते हो, और हम तुम्हें सेवा का उपयोग करने का गैर-अनन्य अधिकार प्रदान करते हैं। सेवा का उपयोग करते समय, तुम इन शर्तों और सभी लागू कानूनों का पालन करोगे। हम और हमारे सहयोगी सेवा में सभी अधिकारों, शीर्षकों और हितों के मालिक हैं।',
    block5:
      'प्रतिक्रिया. अपि विश्लेषणं, टिप्पणयः, विचाराः, सुझावाः, सुधारणयश्च आगत्य स्वागत्यन्ति। यदि त्वं एतत्तया प्रकारेण सामग्रीं ददासि, तदा अहम् ताम् बिना कस्यचित् प्रतिबन्धानाम् च बिना तुभ्यं क्षेत्रे किञ्चिदपि परिशोधनं कृत्वा प्रयुज्यामि।',
    block6:
      '(ग) प्रतिबंधाः। त्वं न कर्तुमर्हसि: (1) सेवाम् किसी अन्यस्य अधिकाराणाम् अपहरणम्, अनुचितार्थग्रहणम् वा उल्लङ्घनं करिष्याणाम् विधिना उपयुज्य; (2) सेवायाः मॉडेलानाम्, कलनपद्धतीनाम् वा प्रणालीनाम् स्रोतकोडं वा अंतर्गत अवयवान् पत्तुम् प्रयत्नध्वनि: प्रतिलोम अभियांत्रिकी, विघटन, विखण्डन, अनुवादनं वा अन्यथा (यदि इहानि प्रतिबंधाः विधानेन निषिद्धाः नास्ति); (3) सेवायाः निष्कर्षं नोमस्य स्पर्धी मॉडेलान् विकसितुं उपयुज्य; (4) सेवायाः डेटा वा निष्कर्षं किसी स्वचालित वा प्रोग्रामिंग विधिभिः निष्कर्षयितुं (यदि एपीआई द्वारा अनुमत न भवेत्), स्क्रैपिंग, वेब हार्वेस्टिंग वा वेब डेटा निष्कर्षण सहित; (5) सेवायाः निष्कर्षं यदा तत् कृत्रिमरूपेण न निर्मितं भवेत्, तदा तत् कृत्रिमरूपेण निर्मितं इति प्रस्तावयितुं वा अन्यथा आमच्या उपयोग नीतियों का उल्लङ्घनं कुर्य; (6) आमच्या पूर्व सहमति बिना एपीआई कुंजिकाओं क्रय, विक्रय वा हस्तांतरणं कुर्य; वा (7) आमहे तेरह वर्षस्य निम्नतर बालानां वा डिजिटल सहमति की लागू आयु के बालानां किसी व्यक्तिगत सूचना प्रदान कुर्य। त्वं आमच्या दस्तावेजीकरणमधील कोणत्याही दर सीमा आणि इतर आवश्यकतांचे पालन करिष्यसि।',
    block7:
      '(d) तृतीय-पक्ष सेवाः। सेवया सम्बद्धाः कोऽपि तृतीय-पक्ष सॉफ्टवेयरः, सेवाः, अथवा अन्यानि उत्पादाः तैः स्व-नियमैः नियमिताः भवन्ति, तथा तृतीय-पक्ष उत्पादानाम् आरोपणं न कुर्मः।',
    block8:
      'युवरं सामग्रीः। त्वं सेवायै इनपुटम् ("इनपुट") प्रदानं कर्तुं शक्यसि तथा इनपुटम् आधारितं उत्पन्नं च परितर्पितं च आउटपुटम् ("आउटपुट") प्राप्तुं शक्यसि (समूहतः "सामग्री" इति उच्यते)। पक्षयोर् मध्ये, तथा वैधानिकं कानूनं अनुमति देने यत्र पर्यंत, त्वं सर्वं इनपुटम् स्वामिन् असि। नोआम् सामग्रीम् सेवाम् प्रदानं कृत्वा संरक्षणं कृत्वा, वैधानिकान् कानूनान् अनुपालनं कृत्वा, तथा आमस्यं नीतिनियमान् प्रवर्तनं कृत्वा उपयोगं कर्तुं शक्यते। त्वं सामग्र्याः उत्तरदायी असि, यस्याः अन्तर्गतं अस्ति यत् एषा कश्चिद् वैधानिकं कानूनं वा एतान् नियमान् उल्लङ्घनं न कुर्यात् इति सुनिश्चयं कृत्वा।',
    block9:
      'सत्यता. कृत्रिम बुद्धिः और मशीन लर्निंगः शीघ्रं विकसनीय शोध क्षेत्रे आहेत्। आमहं स्वामेव सेवाम् सुधारतुं, अधिक सत्य, विश्वसनीय, सुरक्षित, और लाभदायक बनाने का निरंतर प्रयास करते हैं। मशीन लर्निंगस्य संभाव्यतामय स्वभावात्, कुछ अवसरेषु आमची सेवा प्रयोग करने से अशुद्ध परिणाम हो सकते हैं, जो वास्तविक व्यक्तियों, स्थानों, या तथ्यों को सही ढंग से प्रतिबिंबित नहीं कर सकते। तुम्हें अपने उपयोग के मामले के आधार पर किसी भी परिणाम की सटीकता का उचित मूल्यांकन करना चाहिए, जिसमें मैन्युअल रूप से परिणामों की समीक्षा करना भी शामिल है।',
    subTitle1: 'पंजीकरणं और प्रवेशः',
    subTitle10: 'विभाज्यता',
    subTitle2: 'प्रयोग आवश्यकताएँ',
    subTitle3: 'सामग्री',
    subTitle4: 'शुल्कानि च भुगतानम्',
    subTitle5: 'गोपनीयता, सुरक्षा, और डेटा संरक्षण',
    subTitle6: 'शब्दः और समाप्तिः',
    subTitle7: 'क्षतिपूर्तिः; निषिद्धवचनानि; दायित्वसीमा',
    subTitle8: 'नियमक कानून और अधिकार क्षेत्र',
    subTitle9: 'सामान्य नियम',
    title: 'सेवा शर्तें',
    updateTime: 'अद्यतनीकृतम्: मार्च १५, २०२४',
  },
  trialModal: {
    btn: 'अभी प्रारम्भ करें (केवल $0.99)',
    chat: 'चैटपीडीएफ',
    desc1: 'तुमच्या परीक्षणकालानंतर, तुम्हाला वार्षिक शुल्क $180 आकारले जाईल',
    desc2: 'कदाचित् निरस्त कर',
    focus: 'एकाग्रता',
    hover: 'होवर अनुवाद',
    image: 'प्रतिमा अनुवादः',
    installBtn: 'अधिकार्य प्रदानं प्राप्तुम् एतद् अहल्लीकृत्य स्थापयतु',
    memo: 'प्रियवस्तु प्रबन्धनम्',
    pdf: 'पीडीएफ समानांतर अनुवाद',
    realtime: 'तत्कालानुवादः',
    select: 'शब्द-चयन-अनुवादः',
    title: 'आगमनार्हदानम्',
    trialText: 'सप्ताहस्य परीक्षा (Saptāhasya Pārīkṣā)',
    video: 'वीडियो अनुवाद',
    videoSummary: 'वीडियो सारांश',
    web: 'समानांतरानुवादः',
    webSummary: 'वेब सारांशः',
  },
  upgradeModal: {
    btn: 'अभी अपग्रेड करें',
    chat: {
      free: 'त्वं चैटपीडीएफ सीमां प्राप्तवान्',
      pro: 'इदं मासस्य ChatPDF सीमां त्वं प्राप्तवान्',
    },
    contactStr: 'अग्रिम पुनर्स्थापना का इंतजार कीजिए, या contact@noam.tools पर हमसे संपर्क करें।',
    limitAlertStr:
      'त्वं तव मुक्त योजना सीमां प्राप्तवान्। निरन्तरं क्रियाणुरोधं हेतुं सुधारणम् कुरु।',
    more: 'योजनाओं को देखें',
    pageLimit: { free: 'पीडीएफ पृष्ठ सीमा प्राप्त हुई है' },
    title: 'स्मृत्यार्थ',
    upgradeAlertStr: 'त्वं तव मुफ्त योजना सीमां प्राप्तवानः। निरंतरता के लिए अपग्रेड करोतु।',
    upload: {
      free: 'त्वं तव पीडीएफ अनुवाद सीमा प्राप्तवान्',
      pro: 'आप इस मास की पीडीएफ अनुवाद सीमा तक पहुँच चुके हैं',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'अभी सामेल हों',
      label: 'नवप्रयोक्तृलाभाः:',
      remain: 'मात्रं त्रिंशत् शेषाः',
      text: 'केवलं १०० स्थानानि उपलब्धाः! त्वं तवं अवतिष्ठतु तत्र!',
    },
  },
  aiPdfTranslator: {
    title: 'मुफ्त एआई पीडीएफ अनुवादकः: किसी भी भाषया: पीडीएफं तुलनया सह अनुवद्यतु',
    desc: 'एआई सहायतया पीडीएफ फाइलान् सरलं कस्यचित् भाषायां अनुवादयत। मूलं च अनुवदितं च पाठं समक्षे तुलयतु, वेगवान् च मुफ्तः च।',
    keywords:
      'जीपीटी-४ (जीपीटी-चतुर्), एआई सहायक (एआई सहायकः), अनुवादः, सारांशः, फोकस् (केन्द्रीकरणम्), चैटपीडीएफ (चैटपीडीएफः), मेमो (स्मृतिचिह्नम्), कुशलता (कार्यक्षमता)',
    sourceToTarget: {
      title: 'मुफ्त पीडीएफ अनुवाद उपकरणम्: {{source}} को {{target}} में मुफ्त में अनुवादयतु',
      desc: 'त्वच्छ PDF फाइलान् स्वतः प्रियभाषायां मुक्ततः अनुवादयत। तीव्रं, सत्यं, सुरक्षितं च PDF अनुवादं अत्याधुनिक AI प्रदान्यते।',
    },
    headerIntroduce: {
      title: 'नोअम्: केवलं ऑनलाइन अनुवादः न केवलम्',
      introduce1: {
        title: 'नोम · पीडीएफ पाठक',
        desc: '✨समक्षे अनुवादः + AI प्रश्नोत्तरम्। पीडीएफ फाइलों को शीघ्रं च सटीकतया तव लक्ष्यभाषयां अनुवद्यताम्। सामग्र्या सम्बन्धिनः प्रश्नान् स्वतन्त्रतया पृच्छतु तव पीडीएफ फाइलों को गहनतरं समझने लिए।',
      },
      introduce2: {
        title: 'नोअम् · सह-सम्भोगे अनुवाद एक्स्टेंशन',
        desc: 'सभी तव वेबपृष्ठान् अनुवादन-आवश्यकतान् साधयतु:',
        detail1: { title: 'वेबपृष्ठानुवादः', desc: 'समक्षे द्विभाषिक दर्शनम्' },
        detail2: { title: 'शब्दानुवादः', desc: 'एक-क्लिक त्वरित अनुवादः' },
        detail3: {
          title: 'तत्क्षणं अनुवादः',
          desc: 'शब्दान् वा वाक्यानि विलम्बेन विना अनुवादयतु।',
        },
        detail4: { title: 'प्रतिमा अनुवादः', desc: 'प्रतिमास्त्रanslation सहित प्रतिस्थापयतु' },
        detail5: { title: 'वीडियो अनुवादः', desc: 'उत्तम दर्शनायै द्विभाषिकाः उपशीर्षकाः।' },
        footer:
          'बुद्धिमत्तापूर्णे अनुवादस्य लिए अधिक आर्टिफिशियल इंटेलिजेंस-सहायतया पठन-सुविधाः अनुभवतु!',
      },
    },
    subtitle: 'पीडीएफ़ अनलाइन मुफ्त में अनुवाद करें',
    introduce: {
      module1: {
        detail1: {
          title: 'प्रचण्ड-कालीन समक्ष-समक्ष पीडीएफ अनुवाद',
          desc1:
            'मूलं च अनुवादितं च सामग्रीअं तदाक्षिणं समकालीनं पक्ष-पक्षे व्यवस्थित्वा प्रदर्शयतु',
          desc2: 'सुसमक्रमित स्क्रोलिंगेन द्वे संस्करणे सहजं तुलयत',
          desc3: 'सुस्थिरं पठनानुभवं यच्छति समानं स्वरूपं रक्षतु',
        },
        detail2: {
          title: 'सटीक सामग्री संरेखणं च सत्यापनं च',
          desc1: 'साधारणं प्रमाणीकरणं करणार्थं स्रोत्रपाठस्य अनुवादितपाठेन सह पूर्णं सामंजस्यं',
          desc2: 'सर्वं सामग्रीखण्डं द्वयोरपि संस्करणयोर् यथारूपं मेलते',
          desc3: 'विश्वसनीय परिणामों के लिए अनुवाद मतभेदों को शीघ्र देखकर समाधान करें',
        },
      },
      module2: {
        detail1: {
          title: 'सूक्ष्मानुवादस्य लिए अनेकानि अत्याधुनिकानि एआई मॉडेलानि',
          desc1: 'अपनी अनुवाद आवश्यकताओं के अनुरूप अग्रणी एआई मॉडलों में से चुनें',
          desc2: 'विभिन्न दस्तावेज प्रकारों और उद्योगों के लिए इष्टतम परिणाम सुनिश्चित कीजिए',
          desc3:
            'सुविविधपूर्ण मॉडल विकल्पाः प्रत्येक परिस्थितेः के लिए अनुकूल समाधानानि प्रदायन्ति',
        },
        detail2: {
          title: 'सर्वप्रकारस्य सामग्रीस्यास्तु उन्नत आर्टिफिशियल इंटेलिजेंस अनुवादः',
          desc1: 'अस्माकं प्रबलं एआई मॉडेलः उच्च सच्चता तथा प्राकृतिक भाषा समझं सुनिश्चयति',
          desc2: 'तकनीकी, शैक्षणिक, और रचनात्मक दस्तावेजों को सहजतया संभालता है',
          desc3: 'अनुवाद आवश्यकताओं के लिए विश्वसनीय परिणाम प्रदान करता है',
          desc4: 'उत्तम प्रदर्शनार्थं विभिन्न सामग्री प्रकारेषु बुद्धिमती अनुकूलनम्',
        },
      },
      module3: {
        detail1: {
          title: 'प्रज्ञानवत् दस्तावेजस्य संपर्कः',
          desc1:
            'प्रगतिशील AI प्रयोग्य करकृत् स्वयं चैतन्येन तव PDF तथा प्रस्तुतिकरण फाइल्स संग चैट कर',
          desc2:
            'दस्तावेजस्य सामग्र्याः प्रश्नान् तत्क्षणम् अपृच्छति तथा शुद्धान् उत्तरान् प्राप्नोति',
          desc3: 'दीर्घपद्येषु संक्षिप्तं सारं शीघ्रं निर्मयतु',
        },
        detail2: {
          title: 'गहन सामग्री विश्लेषणं च निर्बाध समन्वयः',
          desc1:
            'कुंजी सूचनाओं को निष्कर्षित करें और कृत्रिम बुद्धिमत्ता-सहायता प्रबुद्धता द्वारा जटिल डेटा का विश्लेषण करें',
          desc2: 'तकनीकी, शैक्षणिक या रचनात्मक सामग्रियों में अंतर्दृष्टि प्राप्त करें',
          desc3:
            'संपूर्ण दस्तावेज प्रबंधन समाधानस्य लिए, असीमितरूपेण अस्माकं पीडीएफ अनुवादकेण समन्वयते',
        },
      },
      module4: {
        detail1: {
          title: 'पीडीएफ अनुवादात् परे: सर्व-एकैक-वेबपृष्ठ अनुवाद समाधानम्',
          desc: 'सर्वेषां ऑनलाइन पठन परिस्थितियों के लिए निर्मितम् अस्माकं शक्तिशालिनं समीप-समीपे अनुवाद-प्रस्तरेणं खोज्यताम्',
          desc1: 'पृष्ठानुवादः: समकालिकं पक्ष-पक्षे दर्शनं सह द्विभाषिकं सामग्रीभं आनन्दयताम्',
          desc2: 'शब्दानुवादः: एकवार चिक्करेण हाइलाइट कृतान् शब्दान् तत्क्षणम् अनुवदतु',
          desc3:
            'तत्क्षणभाषान्तरं: शीघ्रं समझनायै किसी पाठस्य वा वाक्यस्य तत्क्षणे भाषान्तरं कुरूत',
          desc4:
            'प्रतिमा अनुवादः मूल प्रतिमास्त्रैः स्वचालितरूपेण अनुवादितप्रतिमास्त्रैः परिवर्तयतु',
          desc5:
            'वीडियो अनुवादः द्विभाषिक उपशीर्षकैः सह वीडियो दृश्यताम्, ताक्ष्ण्येन अनुभवः प्राप्तः स्यात्',
        },
      },
    },
    question: {
      title: 'प्रायः पूछे जाने वाले प्रश्न',
      answer1: {
        title: 'क्या नोएम पीडीएफ अनुवादक पीडीएफ अनुवाद के लिए निःशुल्क उपयोग करने के लिए है?',
        content:
          'अति हाँ, तुम् सिडर पीडीएफ अनुवादकस्य सहायतया पीडीएफ फाइलों को मुफ्तमया अनुवादित कर सकते हो! हम ५,००० टोकनों की मुफ्त कोटा प्रदान करते हैं, जो बाजारे सामान्यतया प्राप्त होने वाले अधिकांश पीडीएफ दस्तावेजों के अनुवाद के लिए पर्याप्त है। यदि तुम्हें बड़ी फाइलों का अनुवाद करने की आवश्यकता है या उन्नत सुविधाओं की आवश्यकता है, तो तुम अधिक क्षमताओं के लिए हमारी प्रीमियम योजनाओं में अपग्रेड करने का विकल्प चुन सकते हो।',
      },
      answer2: {
        title: 'नोम पीडीएफ अनुवादकः कितनः शुद्धः अस्ति?',
        content:
          'नोम पीडीएफ अनुवादक: अत्याधुनिक एआई प्रौद्योगिकी का उपयोग करके और आपके दस्तावेज़ों के संदर्भ को गहराई से समझकर, अत्यधिक सटीक अनुवाद प्रदान करता है। यद्यपि कोई भी स्वचालित अनुवाद निर्दोष नहीं है, हमारा समांतर प्रदर्शन आपको प्रत्येक अनुवाद की आसानी से समीक्षा और परिष्करण करने की अनुमति देता है, जिससे सुनिश्चित होता है कि अंतिम परिणाम आपकी गुणवत्ता की अपेक्षाओं को पूरा करता है। नोम के साथ विश्वसनीय और सटीक पीडीएफ अनुवाद का अनुभव करें।',
      },
      answer3: {
        title: 'क्या अहं स्कैन किए गए पीडीएफ फ़ाइलों का अनुवाद कर सकता/सकती हूँ?',
        content:
          'अस्तु, त्वं स्कैन कृत पीडीएफ (PDF) को आरएचसी (ओप्टिकल कैरेक्टर रिकग्निशन) प्रौद्योगिक्येन अनुवादयितुं शक्यसे। अस्माकं प्रणाली स्वतः स्कैन कृत दस्तावेजान् तथा प्रतिमा-आधारित पीडीएफ-अन् से पाठं निष्कर्षयति, तत्पश्चात् तस्य सामग्रीणाम् तुभ्यं अनुवादयति। एतत् सुनिश्चययति यत् अपरिवर्तनीया वा प्रतिमा-मात्र पीडीएफ-अपि सत्येन अनुवादितुं शक्यन्ति।',
      },
      answer4: {
        title: 'अनुवादं कति दिनानि लभते?',
        content:
          'अनुवादः शीघ्रं च प्रभावी च अस्ति—अधिकांशं दस्तावेजानि सेकण्डान् अथवा कुटुम्बकान् मिनिटान् अन्तर्गतः प्रक्रिया क्रियते यत्र तेषां लम्बाईं च गुणस्तरं च अवलोक्य। उदाहरणार्थ, एकः मानकः 10-पृष्ठकः पीडीएफ अनुवादितुं आमतः 2 मिनिटान् नूनं न लम्बते। त्वम् तव सर्वान् दस्तावेज-अनुवाद-आवश्यकतान् शीघ्रं परिणति-कालैः आनन्दय।',
      },
      answer5: {
        title: 'पठनायै समीपे-समीपे दर्शनम् अहं धारण कर्तुं शक्नोमि?',
        content:
          'अस्तु, त्वं सदैव तव दस्तावेजान् पक्षपक्षे पठitum् शक्यसे। एषः विन्यासः त्वाम् मूलं च अनुवदितं च सामग्रीश्च सुलभं समीक्षितुं यच्छति, जोघर्षरहितं च सुसाधु च पठनानुभवं सुनिश्चययति।',
      },
    },
    freeTrial: 'मुफ्त परीक्षण',
    toLanguage: { title: 'पीडीएफ एआई अनुवाद युग्मानि', item: '{{source}} इच्छितम् {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'विशेषताएँ',
      blog: 'ब्लॉग',
      button: 'अभी अनुवाद कीजिए',
      faq: 'अक्सर पूछे जाने वाले प्रश्न',
      pricing: 'मूल्यनिर्धारणम्',
    },
    hero: {
      upload: {
        title: 'अपना पीडीएफ अपलोड करें',
        desc: 'या ड्रैग करें और ड्रॉप करें',
        highlight: 'प्रदर्शन के लिए क्लिक करें',
        max: 'मैक्स',
      },
      to: 'ते',
      title: 'मुफ्त पीडीएफ अनुवादक',
      pill: 'एआई-संचालित पीडीएफ अनुवादक',
      model: 'जीपीटी-४ तथा क्लॉड',
      support: 'ओसीआर समर्थनम्',
      free: 'मुफ्त परीक्षण',
      desc: 'तत्क्षणम्, यथार्थानां अनुवादानां मूलं लेआउटं संरक्षयति। नोआम् एआई ओसीआर् तथा पक्ष-पक्षे दृश्यान् समर्थयति।',
      translated: 'नोम् द्वारा अनुवादितम्',
      complete: 'अनुवाद सम्पन्नः',
    },
    ticker: {
      pdf: 'पीडीएफ अनुवाद',
      ocr: 'ओसीआर प्रौद्योगिकी',
      side: 'सह-स्थित',
      format: 'प्रारूपस्थिरता',
      multi: 'बहुभाषिक',
      chat: 'पीडीएफ् साहसा वार्तालाप',
      web: 'वेब अनुवादः',
      secure: 'सुरक्षितः च गोपनीयः च',
    },
    comparison: {
      bad: {
        title: 'स्टैण्डर्ड ट्रान्स्लेशन',
        head: 'फॉर्मेटिंगः च सन्दर्भः च लोपितः',
        text1: 'त्रुटिः: स्थानरचना विकृता। चित्राणि स्थानहीनानि।',
        text2: 'अनुच्छेदाः सन्तस्यन्ति च लिप्यः अनियमिताः। पठनं कठिनं च अशौभ्रं च...',
      },
      dump: { title: 'प्लेन टेक्स्ट डम्प' },
      good: {
        title: 'नोअम एआई अनुवाद',
        tag: 'परिपूर्णफलम्',
        sub: 'परिपूर्णं स्वरूपणं, सन्दर्भज्ञ',
      },
      title: 'नोम एआईं किम् चयेत्?',
      desc: 'कॉपी-पेस्ट अनुवाद से संघर्ष करना बंद करें। मानक उपकरणों और हमारी AI-संचालित संदर्भ-सचेत अनुवाद के बीच अंतर का अनुभव करें।',
    },
    showcase: {
      kicker: 'सहायक दस्तावेज़',
      title1: 'कोई दस्तावेज़',
      title2: 'कोऽपि भाषा',
      carousel1: 'कला',
      carousel2: 'वास्तुशास्त्र',
      carousel3: 'अकादमिकी जर्नल',
      carousel4: 'औषधिः',
      note: 'प्रौद्योगिक, शैक्षिक, च प्रजननीय दस्तावेजान् सुगमतया संचालयतु।',
      carousel5: 'वित्तशास्त्र',
      carousel6: 'धर्म',
      carousel7: 'संविदा',
      carousel8: 'नीति',
    },
    features: {
      big: {
        title: 'प्रगतिमान आर्टिफिशियल इंटेलिजेंस मॉडल (जीपीटी-४, क्लॉड)',
        desc: 'अपनी अनुवाद आवश्यकताओं के अनुरूप प्रमुख AI मॉडलों में से चुनें। विभिन्न दस्तावेज़ प्रकारों के लिए इष्टतम परिणाम सुनिश्चित करें।',
      },
      grid1: {
        title: 'ओसीआर सहायता',
        desc: 'स्कैन किए गए पीडीएफ और छवियों से पाठ तत्काल निकालें और अनुवाद करें।',
      },
      grid2: {
        title: 'उच्च-रिज़ॉल्यूशन निर्यात',
        desc: 'मूल स्वरूपेण सह पीडीएफ प्रारूपेण तुम्हारे अनुवादित दस्तावेज਼ों को डाउनलोड करें।',
      },
      grid3: {
        title: 'समक्ष비म्बनम्',
        desc: 'मूलपाठं च अनुवादितपाठं च तुलयितुं समकालिकं स्क्रोलिंगम्',
      },
      title1: 'अनुवादस्येव न केवलम्',
      line1: 'तकनीकी प्रपत्र.pdf',
      title2: 'यत् क्रान्तिः अस्ति',
      line2: 'भाषा परीक्षणम्: अङ्ग्लभाषा...',
      line4: 'अनुवाद सम्पन्नः (99% शुद्धता)',
      line3: 'मॉडलः GPT-४o (उच्च शुद्धता)',
    },
    testimonials: {
      review1: {
        role: 'अन्वेषकः',
        content:
          'नोअम् एआईः मे शास्त्रीय प्रबन्धान् अनुवादयितुम् घंटासहस्राणि रक्षितवति। द्वयसहस्थित दृश्यः तकनीकी शब्दान् प्रमाणीकर्तुं अत्यन्त उपयोगी अस्ति।',
      },
      review2: {
        role: 'विश्वव्यापी विपणकः',
        content:
          'अहं प्रयुक्तः सर्वोत्तमः पीडीएफ अनुवादकः। यः मूलं स्वरूपं पूर्णतया रक्षति, यः अस्माकं मार्केटिंग डेकों के लिए महत्त्वपूर्णम्।',
      },
      review3: {
        role: 'विधिक परामर्शदाता',
        content:
          'सचिक एवं शीघ्र। अहं तत् करार-अनुवादेषु प्रयुङ्क्ति तथा स्कैन-कृत दस्तावेजानां OCR विशेषता निर्दोषेण कार्य करोति।',
      },
      kicker: 'योगकारैः प्रियः',
      title: 'यत् नः उपयोक्तारः वदन्ति',
    },
    cta: {
      title: 'भाषा-सीमान्तान् भङ्क्तुम् तैयाराः स्थः?',
      hint: '',
      desc: 'दशसहस्राधिकं योजकाः सखे आजैव नोम एआई सह स्वकीयं दस्तावेजान् अनुवादयितुम् आरभताम्',
      button: 'मुफ्तम् अनुवादं आरम्भयतु',
    },
    languagePairs: {
      desc: 'नोम एआई द्वारा समर्थित लोकप्रिय अनुवाद दिशाएँ',
      title: 'अङ्ग्लभाषायाः पीडीएफ एआई अनुवादजोड़ियः',
    },
    footer: {
      about: 'अस्माकं विषये',
      privacy: 'गोपनीयता नीति',
      contact: 'सपोर्टस्य संपर्कः करोतु',
    },
  },
}

export default TRANSLATION
